import React from 'react';
import { PlanProductCardProps } from '.';
import { Subtitle } from '../../Common/Subtitle';
import { DiscountPill } from '../../Common/DiscountPill';
import { PricePanel, PricePanelTheme } from './PricePanel';

export interface PlanDescriptionProps
  extends Pick<
    PlanProductCardProps,
    | 'imgUrl'
    | 'title'
    | 'discountFormat'
    | 'planDescription'
    | 'billingPrice'
    | 'billingDescription'
  > {}

export function PlanDescription({
  imgUrl,
  title,
  discountFormat,
  planDescription,
  billingPrice,
  billingDescription,
}: PlanDescriptionProps) {
  return (
    <div className='flex flex-col sm:flex-row gap-x-6 gap-y-4 flex-1 items-center xmd:flex-wrap lg:flex-nowrap'>
      <img src={imgUrl} className='w-[160px] h-[110px]' />
      <div className='flex flex-col gap-y-2 items-center sm:items-start'>
        <div className='flex flex-row gap-x-4 items-center flex-wrap gap-y-2'>
          <Subtitle label={title} />
          {discountFormat && (
            <DiscountPill label={`${discountFormat} off applied`} />
          )}
        </div>
        <span className='text-base leading-relaxed v2-text-neutral-900'>
          {planDescription}
        </span>
        {billingPrice && (
          <div className='flex flex-row gap-x-2 gap-y-2 items-end flex-wrap justify-center min-[390px]:justify-start'>
            <PricePanel
              billingPrice={billingPrice}
              theme={discountFormat ? PricePanelTheme.Gray : undefined}
            />
            <span className='text-xs v2-text-neutral-500'>
              {billingDescription}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
